import { render, staticRenderFns } from "./tasklist.vue?vue&type=template&id=5b07b828&"
import script from "./tasklist.vue?vue&type=script&lang=ts&"
export * from "./tasklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tasklist.vue"
export default component.exports